<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/about_new.jpg');
            background-position: top !important;
          "
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">{{ $t("aboutus") }}</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div>
      <div class="mx-0 row align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 px-8">
          <div class="px-md-4 mx-0 pa-0 text-content aboutus">
            <div class="aboutus_new_content">
              <h3>{{ $t("aboutus_new_headline") }}</h3>
              <p>{{ $t("aboutus_new_para1") }}</p>
              <p>{{ $t("aboutus_new_para2") }}</p>
              <p>{{ $t("aboutus_new_para3") }}</p>
            </div>
            <div class="aboutus-image-big aboutus-image-new">
              <img
                class="aboutus-image"
                src="/static/img/Training-Academy-Knorr-Bremse-EN-3.png"
              />
            </div>
            <h3>{{ $t("aboutus_headline") }}</h3>
            <div class="row">
              <div class="col-md-4">
                <div
                  class="aboutus-image"
                  style="background-image: url('/static/img/brakes.jpg')"
                ></div>
                <h4>{{ $t("knowPremium") }}</h4>
                <ul style="list-style: square">
                  <li>{{ $t("aboutus_knowhow_line1") }}</li>
                  <li>{{ $t("aboutus_knowhow_line2") }}</li>
                  <li>{{ $t("aboutus_knowhow_line3") }}</li>
                </ul>
              </div>
              <div class="col-md-4">
                <div
                  class="aboutus-image"
                  style="background-image: url('/static/img/worldmap.jpg')"
                ></div>
                <h4>{{ $t("aboutus_partnership_headline") }}</h4>
                <ul style="list-style: square">
                  <li>{{ $t("aboutus_partnership_line1") }}</li>
                  <li>{{ $t("aboutus_partnership_line2") }}</li>
                </ul>
              </div>
              <div class="col-md-4">
                <div
                  class="aboutus-image"
                  style="background-image: url('/static/img/show_drill.jpg')"
                ></div>
                <h4>{{ $t("aboutus_security_headline") }}</h4>
                <ul style="list-style: square">
                  <li>{{ $t("aboutus_security_line1") }}</li>
                  <li>{{ $t("aboutus_security_line2") }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Right Area -->
        <div class="col-xl-3 pl-8">
          <Contact />
          <div class="video_section pt-10 pl-4">
            <button class="video_item mb-2" @click.stop="handleVideoClick">
              <img class="video_image" src="/static/img/video_thumbnail.jpg" />
              <img
                class="play_image"
                src="/static/img/play-circle.png"
                style="width: 53px; height: 53px"
              />
            </button>
            <h5 class="video_head">{{ $t("aboutus_knowhow_headline") }}</h5>
            <v-dialog
              v-model="openAddDialog"
              width="unset"
              content-class="vdialognew"
            >
              <button
                class="stop_video_btn"
                @click="openAddDialog = false"
              ></button>
              <video
                @contextmenu.prevent
                preload="auto"
                class="video_popup"
                controls
                autoplay
                v-if="
                  (openAddDialog == true && $locale === 'en') ||
                  $locale === 'hu' ||
                  $locale === 'fr' ||
                  $locale === 'pl' ||
                  $locale === 'es' ||
                  $locale === 'ru' ||
                  $locale === 'kk' ||
                  $locale === 'it'
                "
                controlsList="nodownload"
              >
                <source
                  :src="`/files/images/KNORR_2_English_380mb.mp4`"
                  type="video/mp4"
                />
              </video>
              <video
                @contextmenu.prevent
                preload="auto"
                class="video_popup"
                controls
                controlsList="nodownload"
                oncontextmenu="return false;"
                autoplay
                v-if="openAddDialog == true && $locale === 'de'"
              >
                <source
                  :src="`/files/images/KNORR_2_German_380mb.mp4`"
                  type="video/mp4"
                />
              </video>
            </v-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  data() {
    return {
      tenants: [],
      venues: [],
      sortedVenues: [],
      contactPersons: [],
      countries: [],
      selectedTenantPanel: null,
      openAddDialog: false,
    };
  },

  mounted() {
    document.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
  },

  methods: {
    handleVideoClick() {
      this.openAddDialog = true;

      if (typeof window.clarity !== "undefined") {
        window.clarity("event", "About Us Video- Get to Know Us");
      }
    },
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
  },
  beforeDestroy() {
    // Clean up the event listener when the component is destroyed
    document.removeEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
  },
};
</script>
